var _defs, _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 984,
    height: 984,
    viewBox: "0 0 984 984",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f65d32;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n        filter: url(#filter);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 227.531,
    y: 90,
    width: 528.781,
    height: 700,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 492,
    cy: 492,
    r: 492
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Color_Fill_1",
    "data-name": "Color Fill 1",
    className: "cls-2",
    d: "M490,90c18.036,3.377,49.924,5.6,67,12,41.908,15.707,81.269,56.865,98,98,6.533,16.062,6.034,37.947,12,54q0.5,72.492,1,145c102.34-.685,87,112.08,87,214,0,42.709,6.026,98.067-8,129-10.162,22.412-36.823,39.058-61,48H299c-24.1-9.011-50.931-25.533-61-48-17.256-38.5-8-155.2-8-211,0-31.368-2.037-62.867,8-85,14.712-32.442,42.066-38.318,80-48-0.277-40.85-7.7-115.153,4-147V226c20.6-55.625,51.206-103.626,106-124,18.225-6.776,38.389-4.061,61-8Q489.5,92,490,90Zm-21,88c-12.375,12.64-38.834,13.308-48,29a221.324,221.324,0,0,0-16,34q0.5,78.492,1,157l174-1C581.218,267.571,606.513,176.672,469,178Zm9,350c-36.531,29.936-42.59,40.816-11,81-0.813,49.411-7.71,77.164,24,97,31.344-5.714,25.992-39.422,26-76V609c3.046-9.222,17.2-14.878,21-25,3.57-9.518-2.572-20.7-4-25C525.541,533.537,512.776,527.3,478,528Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Lock.643a66f0.svg";
export { ForwardRef as ReactComponent };